<div class="tbl-cont">
  <div class="action-bar" [class.has-search]="!!settings.textFilterConfig">
    <!-- edit columns -->
    <div class="action-buttons-table">
      <!-- Action groups rendered BEFORE View Columns -->
      <ng-container *ngFor="let ag of currentSettings.actionSettings">
        <ng-container *ngIf="!ag.afterViewColumns">
          <ng-container *ngIf="ag.plain; else dropdown">
            <ng-container *ngFor="let act of ag.actions">
              <button
                mat-stroked-button
                [ngClass]="ag.buttonClass || act.buttonClass || ''"
                (click)="runAction(act)"
              >
                <mat-icon *ngIf="act.icon">{{ act.icon }}</mat-icon>
                {{ act.displayName | translate }}
              </button>
            </ng-container>
          </ng-container>
          <ng-template #dropdown>
            <button mat-stroked-button="" [matMenuTriggerFor]="menu">
              <mat-icon>expand_more</mat-icon>
              {{ ag.displayName | translate }}
            </button>
            <mat-menu #menu="matMenu">
              <button
                (click)="runAction(act)"
                *ngFor="let act of ag.actions; index as i"
                mat-menu-item=""
              >
                {{ act.displayName | translate }}
              </button>
            </mat-menu>
          </ng-template>
        </ng-container>
      </ng-container>

      <button mat-stroked-button="" color="gray" [matMenuTriggerFor]="menu">
        <mat-icon>expand_more</mat-icon>
        <span>{{ 'ViewColumns' | translate }}</span>
      </button>
      <mat-menu #menu="matMenu">
        <!-- Main columns -->
        <ng-container *ngFor="let col of currentSettings.columns; index as i">
          <div *ngIf="!col.parent && col.name" mat-menu-item="">
            <mat-checkbox
              color="primary"
              (click)="toggleVisibility($event, i); $event.stopPropagation()"
              [checked]="col.visible"
              >{{ col.name | translate }}</mat-checkbox
            >
          </div>
        </ng-container>

        <!-- Nested Columns -->
        <ng-container *ngFor="let mainItem of objectKeys(parentColumnSettings)">
          <button mat-menu-item="" [matMenuTriggerFor]="sub_menu">
            {{ mainItem }}
          </button>
          <mat-menu #sub_menu="matMenu">
            <div
              *ngFor="let subItem of parentColumnSettings[mainItem]"
              mat-menu-item=""
            >
              <mat-checkbox
                color="primary"
                (click)="
                  toggleVisibilityById($event, subItem.id);
                  $event.stopPropagation()
                "
                [checked]="subItem.visible"
                >{{ subItem.name }}</mat-checkbox
              >
            </div>
          </mat-menu>
        </ng-container>
      </mat-menu>

      <button
        type="button"
        class="filter-guide-link"
        (click)="openFilterGuide()"
      >
        <mat-icon>help_outline</mat-icon>
        {{ "FilterUsageGuideTrigger" | translate }}
      </button>

      <!-- Advanced Filters button -->
      <button
        *ngIf="currentSettings.enableAdvancedFilters"
        mat-stroked-button
        [class.active-filters]="getAdvancedFilterCount() > 0"
        (click)="toggleAdvancedFilters()"
        type="button"
      >
        <mat-icon>filter_list</mat-icon>
        {{ "AdvFilterButton" | translate }}
        <span *ngIf="getAdvancedFilterCount() > 0" class="filter-badge">
          {{ getAdvancedFilterCount() }}
        </span>
      </button>

      <!-- Action groups rendered AFTER View Columns -->
      <ng-container *ngFor="let ag of currentSettings.actionSettings">
        <ng-container *ngIf="ag.afterViewColumns">
          <ng-container *ngIf="ag.plain; else dropdownAfter">
            <span *ngIf="ag.label" class="action-group-label" [title]="ag.label">
              <mat-icon>link</mat-icon>{{ ag.label }}
            </span>
            <ng-container *ngFor="let act of ag.actions">
              <button
                mat-stroked-button
                [ngClass]="ag.buttonClass || act.buttonClass || ''"
                (click)="runAction(act)"
              >
                <mat-icon *ngIf="act.icon">{{ act.icon }}</mat-icon>
                {{ act.displayName | translate }}
              </button>
            </ng-container>
          </ng-container>
          <ng-template #dropdownAfter>
            <button mat-stroked-button="" [matMenuTriggerFor]="menuAfter">
              <mat-icon>expand_more</mat-icon>
              {{ ag.displayName | translate }}
            </button>
            <mat-menu #menuAfter="matMenu">
              <button
                (click)="runAction(act)"
                *ngFor="let act of ag.actions"
                mat-menu-item=""
              >
                {{ act.displayName | translate }}
              </button>
            </mat-menu>
          </ng-template>
        </ng-container>
      </ng-container>
    </div>

    <div
      class="search-content"
      *ngIf="
        !!currentSettings.textFilterConfig ||
        !!currentSettings.autocompleteTextFilterConfig
      "
    >
      <app-user-search-autocomplete
        *ngIf="currentSettings.autocompleteTextFilterConfig; else textFilter"
        [placeholder]="'SearchPlaceholder' | translate"
        [columnsToSearch]="currentSettings.autocompleteTextFilterConfig.columns"
        [columnsWithRegex]="
          currentSettings.autocompleteTextFilterConfig.columnsWithRegex
        "
        [coreFilters]="filtersFromColumns"
        [anchorChild]="currentSettings.anchorChild"
        [tableName]="currentSettings.entity"
        [searchString]="
          currentSettings.autocompleteTextFilterConfig.value ?? ''
        "
        (event)="event.next($event)"
        (onSearchChange)="onAutocompleteSearchChange($event)"
        (onClearSelection)="onAutocompleteSearchChange(null)"
      ></app-user-search-autocomplete>
      <ng-template #textFilter>
        <div class="input-container">
          <mat-icon>search</mat-icon>
          <input
            type="text"
            [attr.placeholder]="'SearchPlaceholder' | translate"
            [(ngModel)]="searchval"
            (keyup)="handleSearchChange($event)"
          />
        </div>
      </ng-template>
    </div>
  </div>

  <!-- Advanced Filters panel -->
  <div
    class="advanced-filters-panel"
    *ngIf="currentSettings.enableAdvancedFilters && showAdvancedFilters"
  >
    <app-advanced-filters
      [settings]="currentSettings"
      [activeFilters]="currentSettings.advancedFilters ?? []"
      (filtersChange)="onAdvancedFiltersChange($event)"
    ></app-advanced-filters>
  </div>

  <div
    #tblBody
    class="tbl-body"
    data-testid="table-body"
    [class.tbl-initial-loading]="!hasLoaded"
    [class.tbl-reloading]="isReloading"
    [attr.aria-busy]="isReloading || !hasLoaded"
  >
  <mat-progress-bar
    *ngIf="isReloading"
    class="tbl-progress"
    mode="indeterminate"
    color="primary"
    data-testid="table-loading-bar"
    [attr.aria-label]="'TableLoadingAria' | translate"
  ></mat-progress-bar>
  <table
    mat-table=""
    *ngIf="dataSource"
    [dataSource]="dataSource"
    matSort=""
    multiTemplateDataRows=""
  >
    <ng-container matColumnDef="select">
      <th class="b-table-header" mat-header-cell="" *matHeaderCellDef="">
        <!-- [checked]="selection.hasValue() && isAllSelected()"
        [indeterminate]="selection.hasValue() && !isAllSelected()" -->
        <mat-checkbox
          color="primary"
          (change)="$event ? toggleAllRows() : null"
          [checked]="selection.type === 'all'"
          [indeterminate]="
            selection.type === 'all-some' || selection.type === 'none-some'
          "
          [aria-label]="checkboxLabel()"
        >
        </mat-checkbox>
      </th>
      <td class="b-table" mat-cell="" *matCellDef="let row">
        <!-- [checked]="selection.isSelected(row)" -->
        <mat-checkbox
          color="primary"
          (click)="$event.stopPropagation()"
          (change)="$event ? toggleOneRow(row) : null"
          [checked]="isSelected(row)"
          [aria-label]="checkboxLabel(row)"
        >
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container
      [matColumnDef]="col.id"
      *ngFor="let col of currentSettings.columns; index as i; trackBy: trackByColumnId"
    >
      <!-- mat-sort-header
      sortActionDescription="Sort by {{ col.name }}" -->
      <th class="b-table-header" mat-header-cell="" *matHeaderCellDef="">
        <span class="hc">
          {{ col.name | translate }}
          <button
            *ngIf="col.id !== 'acc' && col.type !== 'component' && col.type !== 'kyc-list'"
            mat-icon-button=""
            [matMenuTriggerFor]="filterMenu"
            (click)="openFilter(col)"
          >
            <img
              *ngIf="currentSettings.columns[i]?.hasActiveFilter || currentSettings.columns[i]?.sort; else outlineIcon"
              src="assets/icons/icon-filter-filled.svg"
              class="filter-icon"
              alt="filter"
              width="16"
              height="16"
            />
            <ng-template #outlineIcon>
              <img
                src="assets/icons/icon-filter-outline.svg"
                class="filter-icon"
                alt="filter"
                width="16"
                height="16"
              />
            </ng-template>
          </button>
        </span>
      </th>
      <td class="b-table" mat-cell="" *matCellDef="let element">
        <div [ngSwitch]="col.type">
          <div *ngSwitchCase="'accordeon'">
            <button
              (click)="accordeonButtonClick($event, element)"
              mat-icon-button=""
            >
              <mat-icon>expand_more</mat-icon>
            </button>
          </div>

          <div *ngSwitchCase="'json'"
            [ngClass]="col.config?.cellClass ? col.config.cellClass(col.root ? element[col.root]?.[col.id] : element[col.id]) : ''"
            [style.fontSize]="col.config?.fontSize">
            <ng-container *ngIf="col.root && element[col.root]">
              {{ formatCellValue(element[col.root!][col.id]) }}
            </ng-container>
          </div>

          <div *ngSwitchCase="'link'">
            <ng-container *ngIf="element">
              <!-- If a handler is provided in the column config, call it instead of using routerLink -->
              <a
                *ngIf="col.config?.handler"
                class="tbl-link"
                href="#"
                (click)="handleLinkHandler(col, element); $event.preventDefault(); $event.stopPropagation();"
                >{{ (element[col.id] || '')?.substring(0, 6) }}</a
              >

              <!-- Default behavior: internal routerLink (optionally open in new tab) -->
              <a
                *ngIf="!col.config?.handler && !col.config?.newtab && element && (element[col.id] || col.entityPath && element[col.entityPath])"
                class="tbl-link"
                routerLink="/firm/{{ col.entityName ? col.entityName : settings.entity }}/{{ col.entityPath ? element[col.entityPath] : element[col.id] }}"
                >{{ (element[col.id] || '')?.substring(0, 6) }}</a
              >

              <a
                *ngIf="!col.config?.handler && col.config?.newtab && element && (element[col.id] || col.entityPath && element[col.entityPath])"
                class="tbl-link"
                target="_blank"
                routerLink="/firm/{{ col.entityName ? col.entityName : settings.entity }}/{{ col.entityPath ? element[col.entityPath] : element[col.id] }}"
                >{{ (element[col.id] || '')?.substring(0, 6) }}</a
              >
            </ng-container>
          </div>

          <div class="events" *ngSwitchCase="'events'">
            <ng-container *ngFor="let eve of col.config.emmiters">
              <a class="emmiters-eve" (click)="emit(eve, element)">
                <ng-container *ngIf="eve.icon">
                  <mat-icon>{{ eve.icon }}</mat-icon>
                </ng-container>
                <ng-container *ngIf="eve.display">
                  {{ eve.display }}
                </ng-container>
              </a>
              <span> | </span>
            </ng-container>
          </div>

          <div *ngSwitchCase="'date'">{{ element[col.id] | date }}</div>

          <div *ngSwitchCase="'url'">
            <a href="{{ element[col.id] }}">{{ col.linkText }}</a>
          </div>

          <div *ngSwitchCase="'component'">
            <ng-container
              *ngTemplateOutlet="
                cell || defaultCell;
                context: { $implicit: element, col }
              "
            ></ng-container>
          </div>

          <div *ngSwitchCase="'downloadFile'">
            <a *ngIf="element[col.id]" (click)="download(element[col.id])" style="cursor: pointer">
              {{ element[col.id].fileName }}
            </a>
          </div>

          <div *ngSwitchCase="'kyc-list'" class="kyc-list-cell">
            <div
              *ngFor="let kyc of getKycList(element[col.id])"
              class="kyc-list-item"
            >
              <mat-icon
                class="kyc-status-icon"
                [class.kyc-success]="kyc.passed"
                [class.kyc-fail]="!kyc.passed"
              >{{ kyc.passed ? 'check_circle' : 'cancel' }}</mat-icon>
              <span class="kyc-date" [style.fontSize]="col.config?.fontSize">
                {{ kyc[col.config?.dateField || 'created_at'] | date: 'dd/MM/yyyy HH:mm' }}
              </span>
              <button
                *ngIf="!kyc.passed"
                mat-icon-button
                class="kyc-info-btn"
                (click)="emitKycInfo(col, kyc, element); $event.stopPropagation()"
              >
                <mat-icon>info</mat-icon>
              </button>
            </div>
          </div>

          <div *ngSwitchDefault=""
            [ngClass]="col.config?.cellClass ? col.config.cellClass(element[col.id]) : ''"
            [style.fontSize]="col.config?.fontSize">{{ col.config?.formatter ? col.config.formatter(element[col.id], element) : (formatCellValue(element[col.id]) || (col.config?.fallback ?? '')) }}</div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td
        class="b-table"
        mat-cell=""
        *matCellDef="let element"
        [attr.colspan]="displayedColumns.length"
      >
        <ng-container *ngIf="element === expandedElement">
          <ng-template accordeonHost=""></ng-template>
        </ng-container>
      </td>
    </ng-container>

    <ng-template #defaultCell="" let-element="" let-col="">
      {{ element[col.id] }}
    </ng-template>

    <tr mat-header-row="" *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row=""
      class="table-row"
      [class.clickable-row]="!!currentSettings.anchorChild"
      *matRowDef="let row; columns: displayedColumns"
      (click)="rowClick($event, row)"
    ></tr>
    <tr
      mat-row=""
      *matRowDef="let row; columns: ['expandedDetail']"
      class="example-detail-row"
    ></tr>

    <!-- No rows: placeholder rows while the first page loads, then the empty state. -->
    <ng-container *matNoDataRow>
      <ng-container *ngIf="!hasLoaded; else emptyStateRow">
        <tr
          *ngFor="let r of skeletonRows"
          class="mat-mdc-row mdc-data-table__row tbl-skeleton-row"
          data-testid="table-skeleton-row"
          aria-hidden="true"
        >
          <td
            *ngFor="let c of displayedColumns; index as ci"
            class="mat-mdc-cell mdc-data-table__cell b-table"
          >
            <ngx-skeleton-loader
              *ngIf="c === 'select'; else skeletonBar"
              appearance="line"
              animation="progress"
              [theme]="{ width: '18px', height: '18px', 'border-radius': '4px', 'margin-bottom': '0', 'vertical-align': 'middle' }"
            ></ngx-skeleton-loader>
            <ng-template #skeletonBar>
              <ngx-skeleton-loader
                appearance="line"
                animation="progress"
                [theme]="{ width: 45 + ((r * 3 + ci * 5) % 7) * 7 + '%', height: '12px', 'border-radius': '6px', 'margin-bottom': '0', 'vertical-align': 'middle' }"
              ></ngx-skeleton-loader>
            </ng-template>
          </td>
        </tr>
      </ng-container>
      <ng-template #emptyStateRow>
        <tr class="mat-mdc-row mdc-data-table__row tbl-empty-row">
          <td
            class="mat-mdc-cell mdc-data-table__cell"
            [attr.colspan]="displayedColumns.length"
          >
            <div class="tbl-empty-state" data-testid="table-empty-state" role="status">
              <div class="tbl-empty-state-icon">
                <mat-icon>{{ hasActiveFilters ? 'search_off' : 'inbox' }}</mat-icon>
              </div>
              <h3 class="tbl-empty-state-title">
                {{ (hasActiveFilters ? 'TableNoResultsTitle' : 'TableEmptyTitle') | translate }}
              </h3>
              <p class="tbl-empty-state-hint">
                {{ (hasActiveFilters ? 'TableNoResultsHint' : 'TableEmptyHint') | translate }}
              </p>
              <button
                *ngIf="hasActiveFilters"
                mat-stroked-button
                type="button"
                class="tbl-empty-state-action"
                data-testid="table-empty-clear-filters"
                (click)="clearAllFilters()"
              >
                <mat-icon>filter_alt_off</mat-icon>
                {{ 'TableClearFilters' | translate }}
              </button>
            </div>
          </td>
        </tr>
      </ng-template>
    </ng-container>
  </table>
  </div>

  <div class="paginator-bar">
    <div class="counter">
      <span> {{ getSelectionLength() }} {{ 'SelectedCount' | translate }} </span>
    </div>
    <mat-paginator
      [length]="dataSource?.amount"
      [pageSizeOptions]="[5, 10, 20, 50, 100]"
      [pageSize]="currentSettings.pageSize ?? 20"
      [pageIndex]="currentSettings.pageIndex ?? 0"
      [attr.aria-label]="'PaginatorAriaLabel' | translate"
    >
    </mat-paginator>
  </div>

  <mat-menu #filterMenu="matMenu" class="menu-filter">
    <!-- Lazy content: a fresh app-filter is built each time the menu opens, so it
         reads the current column's applied filter and restores its value/operator. -->
    <ng-template matMenuContent>
      <app-filter
        *ngIf="filteringColumn"
        [settings]="currentSettings"
        [column]="filteringColumn"
        (columnChanges)="columnChange($event)"
      ></app-filter>
    </ng-template>
  </mat-menu>
</div>
